<template>
  <transition name="modal">
    <div v-if="isVisible" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-content">
          <div class="modal-row two-columns">
            <div class="column">
              <label>友链名称</label>
            </div>
            <div class="column">
              <el-input
                v-model="localFriendLink.title" 
                placeholder="请输入友链名称"
              ></el-input>
            </div>
          </div>
          <div class="modal-row two-columns">
            <div class="column">
              <label>友链介绍</label>
            </div>
            <div class="column">
              <el-input
                v-model="localFriendLink.desc" 
                placeholder="请输入友链介绍"
              ></el-input>
            </div>
          </div>

          <div class="modal-row two-columns">
            <div class="column">
              <label>友链地址</label>
            </div>
            <div class="column">
              <el-input 
                v-model="localFriendLink.link" 
                placeholder="请输入友链地址"
              ></el-input>
            </div>
          </div>

          <div class="modal-row two-columns">
            <div class="column">
              <label>友链封面</label>
            </div>
            <div class="column">
              <el-input
                v-model="localFriendLink.img" 
                placeholder="请输入友链封面"
              ></el-input>
            </div>
          </div>
          
          <!-- 第三行：操作按钮 -->
          <div class="modal-row button-row">
            <el-button @click="closeModal">关闭窗口</el-button>
            <el-button @click="clearForm">清空数据</el-button>
            <el-button type="primary" @click="submitForm">提交数据</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Message } from 'element-ui';
import { save } from '@/api/friendLink';

export default {
  name: 'CreateFriendLink',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    friendLink: {
      type: Object,
      default: () => ({
        id: null,
        title: '',
        desc: '',
        link: '',
        img: '',
        status: "1"
      })
    }
  },
  data() {
    return {
      localFriendLink: {
        ...this.friendLink
      }
    }
  },
  methods: {
    closeModal() {
      this.clearForm();
      this.isVisible = !this.isVisible;
      this.$emit('update:visible', false);
    },
    clearForm() {
      this.localFriendLink = {}
    },
    async submitForm() {
      if (!this.localFriendLink.title) {
        Message.error('友链名称必填！');
        return;
      }
      if (!this.localFriendLink.desc) {
        Message.error('友链介绍必填！');
        return;
      }
      if (!this.localFriendLink.img) {
        Message.error('友链封面必填！');
        return;
      }
      if (!this.localFriendLink.link) {
        Message.error('友链地址必填！');
        return;
      }
      this.localFriendLink.status = "1"; 
      try {
        const resp = await save(this.localFriendLink);
        if (resp.code === 200 && resp.success) {
          Message.success('操作成功！');
          this.closeModal();
        } else {
          Message.error(resp.msg || '操作失败');
        }
      } catch (error) {
        Message.error('请求失败: ' + (error.msg || error.msg));
      }
    }
  },
  watch: {
    friendLink(newVal) {
      this.localFriendLink = { ...newVal };
    }
  }
}
</script>

<style scoped>

@media(max-width: 768px){
.modal-container {
  width: 90% !important;
  padding: 6px !important;
}
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 50%;
  min-height: 300px;
  /* iOS风格毛玻璃效果 */
  background-color: rgba(255, 255, 255, 0.6);
  /* 提高透明度 */
  backdrop-filter: blur(16px) saturate(180%);
  /* 增加模糊和饱和度 */
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-row {
  margin-bottom: 20px;
}

.two-columns {
  display: flex;
  align-items: center;
}

.column {
  flex: 1;
}

.status-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.column:first-child {
  margin-right: 15px;
  min-width: 100px;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.button-row button {
  margin-left: 10px;
}

/* 过渡动画 */
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(0.9);
}
</style>